import {
  BuildSectionConfig,
  ExtractPayload,
  SectionPayloadDefaults,
  SectionTypeEnum,
} from '@nucleus/types/web/section-data';

export class SectionPayloadDefaultsBuilder {
  private readonly map: Partial<SectionPayloadDefaults> = {};

  addSection<T extends SectionTypeEnum>(type: T, fn: (config: BuildSectionConfig) => ExtractPayload<T>): this {
    (this.map as Record<T, typeof fn>)[type] = fn;
    return this;
  }

  addGenerated(type: SectionTypeEnum, label: string): this {
    this.map[type] = () => {
      throw new Error(`${label} sections are generated and should not use defaults`);
    };
    return this;
  }

  build(): SectionPayloadDefaults {
    return this.map as SectionPayloadDefaults;
  }
}
